import BlogList from "./BlogList";
const Home = ({ blogs, isLoading }) => {
  return (
    <div className="home">
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <BlogList blogs={blogs} title="All Blogs" />
      )}
    </div>
  );
};

export default Home;
